import {
  attachFileToVectorStore,
  createVectorStore,
} from "@/lib/utils/vectorStoreUtils";

// SIMPLIFIED: Vector store management is now handled by thread store
// This file is kept for backward compatibility but delegates to thread store

// Process file for embeddings using vector store
export const processFileForEmbeddingsSimple = async (
  file,
  currentThreadId,
  toast
) => {
  if (!file) return null;

  try {
    // SIMPLIFIED: Get vector store ID from thread store
    const { useThreadStore } = await import("@/store/threadStore");
    const threadStore = useThreadStore.getState();
    const threadVectorStoreId =
      await threadStore.ensureThreadVectorStore(currentThreadId);

    if (!threadVectorStoreId) {
      throw new Error("Could not create or find vector store ID");
    }

    try {
      // Get or create file object
      let fileObj = file.file;

      // If file is not available, try to download it from storage
      if (!fileObj && file.path) {
        try {
          const { supabase } = await import("@/lib/supabase");
          // The file path should already include the user ID if it was uploaded with the new system
          // Path format: {userId}/thread_{threadId}_origname={filename}_{timestamp}_{random}.ext
          const { data: urlData } = await supabase.storage
            .from(file.bucketName || "chat")
            .createSignedUrl(file.path, 3600);

          if (urlData?.signedUrl) {
            const response = await fetch(urlData.signedUrl);
            if (response.ok) {
              const blob = await response.blob();
              fileObj = new File([blob], file.name, { type: file.type });
            }
          }
        } catch (downloadError) {
          console.error(
            "Error downloading file for vector store:",
            downloadError
          );
        }
      }

      // If we have a file object, attach it to the vector store
      if (fileObj) {
        const attachResult = await attachFileToVectorStore(
          { file: fileObj },
          threadVectorStoreId
        );

        return {
          success: true,
          jobId: attachResult.vectorStoreFileId,
          fileId: attachResult.fileId,
          vectorStoreId: threadVectorStoreId,
          method: "vector_store",
        };
      } else {
        throw new Error("Could not obtain file for vector store processing");
      }
    } catch (vectorStoreError) {
      console.error("Error attaching to vector store:", vectorStoreError);
      throw vectorStoreError;
    }
  } catch (error) {
    console.error("Error in processFileForEmbeddingsSimple:", error);
    if (toast) {
      toast({
        title: "Warning",
        description: `Could not process file for embeddings: ${error.message}`,
        variant: "warning",
      });
    }
    return null;
  }
};

// DEPRECATED: Use thread store ensureThreadVectorStore instead
export const ensureVectorStoreForThread = async (threadId) => {
  console.warn(
    "ensureVectorStoreForThread is deprecated. Use thread store ensureThreadVectorStore instead."
  );

  try {
    const { useThreadStore } = await import("@/store/threadStore");
    const threadStore = useThreadStore.getState();
    return await threadStore.ensureThreadVectorStore(threadId);
  } catch (error) {
    console.error("Error in deprecated ensureVectorStoreForThread:", error);
    return null;
  }
};

// Export the imported functions for convenience
export { attachFileToVectorStore, createVectorStore };
